import { resolveOutlineProp } from "~/lib/resolvers";
const shadows = {
  xsmall: "0 0 2px 0 rgba(0, 0, 0, 0.4)",
  small: "0 4px 4px 0 rgba(0, 0, 0, 0.4)",
  middle: "0 7px 22px rgb(0 0 0 /  0.2)",
  large: "0 7px 45px rgba(0, 0, 0, 0.2)",
  outline: (theme, value, color) => resolveOutlineProp(theme, value, color)
};
export default shadows;